import React, { useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

// hooks

// selectors

// components

import { PermissionMap } from '@components/common/nav/AdminMemberSideNav';
import SecureInboxSummary from '@components/individualPortal/secureInbox/subComponents/SecureInboxSummary';
import { InboxContextProvider } from '@contexts/InboxContext';

// ActionCreators
import { setSelectedMember } from '@actions/common/actionCreators';
import { fetchConsumerInboxUnreadNotificationCount } from '@actions/individualPortal/secureInbox/secureInboxActionCreators';
// type

//Const
import { PAGE_TYPE } from '@constants/crm/displayPageType';
import { SideNavContainer } from '../members/utils';

interface IRemoteProps {
    householdUserId: string;
    householdFirstName: string;
    householdLastName: string;
    encHouseHoldId: string;
    householdId: string;
    householdUser: string;
    calheersEnv: string;
    addNewViewCaseUrl: string;
    checkDilog: string;
    permissionMap: PermissionMap | null;
    idmUserStatus?: string | null;
    userStatus?: string | null;
    switchToModuleName: string;
    hhEmail: string;
    hhPhone: string;
    householdEmail: string;
    householdPhone: string;
    householdUserStatus: string;
    hhUserStatus: string;
}

function SecureInboxContainer(props) {
    const [emailShown, setEmailShown] = useState(null);
    const [query, setQuery] = useState('');

    return (
        <SideNavContainer page={PAGE_TYPE.SECURE_INBOX_PAGE}>
            <div className="desktop:grid-col-9" id="main-content">
                <InboxContextProvider>
                    <SecureInboxSummary isLiteFormat={true} {...{ emailShown, setEmailShown, query }} />
                </InboxContextProvider>
            </div>
        </SideNavContainer>
    );
}
const mapStateToProps = state => ({
    environment: state.common.environment,
    activeModuleName: state.common.environment.user.activeModuleName,
    selectedMember: state.common?.sessionDataReducer?.selectedMember,
    router: state?.router,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            fetchConsumerInboxUnreadNotificationCount,
            setSelectedMember,
        },
        dispatch,
    ),
});
export default connect(mapStateToProps, mapDispatchToProps)(SecureInboxContainer);
